<template>
    <div class="offcanvas offcanvas-end offcanvas-01" id="cashdatamodal" tabindex="-1"
        aria-labelledby="offcanvasCreateLabel">
        <div class="offcanvas-header">
            <h5 class="text-dark" id="offcanvasCreateLabel">{{ mode }} Debenture Interest Data</h5>
            <button class="btn btn-danger btn-sm" type="button" data-bs-dismiss="offcanvas" aria-label="Close"
                ref="btnClose">
                <i class="ic-close"></i>
            </button>
        </div>
        <div class="offcanvas-body">
            <div class="row">
                <form class="row align-end" v-on:submit.prevent="submitForm" enctype="multipart/form-data">

                    <div class="col-md-12 mb-16">
                        <label for="">BOID</label>
                        <input type="text" class="form-control" v-model="item.boid" :readonly="!editMode"
                            :disabled="!editMode" />
                        <ErrorSpan :error="errors.boid" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Debenture Holder Name</label>
                        <input type="text" class="form-control" v-model="item.debenture_holder_name" :readonly="!editMode"
                            :disabled="!editMode" />
                        <ErrorSpan :error="errors.debenture_holder_name" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Interest Amount</label>
                        <input type="text" class="form-control" v-model="item.interest_amt" :readonly="!editMode"
                            :disabled="!editMode" />
                        <ErrorSpan :error="errors.interest_amt" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Total Days</label>
                        <input type="text" class="form-control" v-model="item.total_days" :readonly="!editMode"
                            :disabled="!editMode" />
                        <ErrorSpan :error="errors.total_days" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Net Interest Amount</label>
                        <input type="text" class="form-control" v-model="item.net_interest_amt" :readonly="!editMode"
                            :disabled="!editMode" />
                        <ErrorSpan :error="errors.net_interest_amt" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Semi Year</label>
                        <input type="text" class="form-control" v-model="item.semi_quarter" :readonly="!editMode"
                            :disabled="!editMode" />
                        <ErrorSpan :error="errors.semi_quarter" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Remarks</label>
                        <input type="text" class="form-control" v-model="item.remarks" :readonly="!editMode"
                            :disabled="!editMode" />
                        <ErrorSpan :error="errors.remarks" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Fiscal Year</label>
                        <select name="type" class="form-select" :class="{ 'border-red': errors.fiscal_year }"
                            v-model="item.fiscal_year">
                            <option value="" disabled selected>Select Fiscal Year</option>

                            <option v-for="(item, index) in fiscal_years" :key="index" :value="item"> {{ item }}
                            </option>
                        </select>
                        <span v-if="errors.fiscal_years" class="text-danger mt-2 font-size-13">{{ errors.fiscal_years
                        }}</span>
                    </div>

                    <div class="row mb-16">
                        <div class="col-md-6 ">
                            <label for="">File</label>
                            <UploadedFile :file='storage + item.file' :clearUploadedFile="clearUploadedFile"
                                v-if="item.file" />
                            <input type="file" class="form-control" ref="file" @input="handleFileUpload" v-else />
                        </div>
                        <ErrorSpan :error="errors.file" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Company</label>
                        <select name="company_id" class="form-select" :class="{ 'border-red': errors.company_id }"
                            v-model="item.company_id" :readonly="!editMode" :disabled="!editMode">
                            <option value="" disabled selected>Select Company</option>
                            <option v-for="(cat, key) in companies" :key="key" :value="cat.id">{{ cat.name }}</option>
                        </select>
                        <ErrorSpan :error="errors.company_id" />
                    </div>

                    <hr>
                    <div class="col-md-12">
                        <button type="button" aria-label="Close" data-bs-dismiss="offcanvas" class="btn btn-red mr-16">
                            <i class="ic-close mr-8"></i>Cancel
                        </button>
                        <template v-if="editMode">
                            <button v-if="!isLoading" class="btn btn-green" type="submit">
                                <i class="ic-checkmark mr-8"></i>Save
                            </button>
                            <button v-else class="btn btn-green" type="button" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </button>
                        </template>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import CreateMixin from "@/mixins/create.vue"
import ErrorSpan from "@/components/errorspan.vue";
import UploadPreviewMixin from "@/mixins/uploadpreview.vue";
import UploadedFile from "@/components/Utility/UploadedFile.vue";
import MediasMixin from "@/mixins/MediasMixin.vue";

export default {
    name: "DebentureInterestCheckDataModal",
    mixins: [CreateMixin, UploadPreviewMixin, MediasMixin],
    components: { ErrorSpan, UploadedFile },
    props: ['companies'],
    data() {
        return {
            url: 'debenture-interest-check',
            mode: "",
            editMode: true,
            fetch_module: 'FETCH_DEBENTUREs',
            fiscal_years: [
                '2066/67',
                '2067/68',
                '2068/69',
                '2069/70',
                '2070/71',
                '2071/72',
                '2072/73',
                '2073/74',
                '2074/75',
                '2075/76',
                '2076/77',
                '2077/78',
                '2078/79',
                '2079/80',
                '2080/81',
                '2081/82',
                '2082/83',
                '2083/84',
                '2084/85',
                '2085/86',
                '2086/87',
                '2087/88',
                '2088/89',
                '2089/90',
                '2090/91',
                '2091/92',
                '2092/93',
                '2093/94',
                '2094/95',
                '2095/96',
                '2096/97',
                '2097/98',
                '2098/99',
            ]
        };
    },
    computed: {

    },
    mounted() {

        this.$root.$on('EDIT', (data, editMode) => {
            this.editMode = editMode;
            this.isEdit = true;
            this.item = { ...data };
            this.editMode == true ? this.mode = "Edit" : this.mode = "View";
        });

    },
};
</script>

